import { useQuery } from "@apollo/client";
import { GET_PERSON_DUES_ORDERS_QUERY } from "@/pages/people/[pgaId]/person/queries";
import { DuesOrdersData, ACTIVE_DUES_ORDER_STATUSES, findMatchingDuesOrder, buildDuesMetric } from "@/lib/duesHelpers";
import { hasDuesPayingProgram } from "@/pages/people/_utils";
import { Person } from "@/types";
import { MetricCardType } from "@/components/MetricCard/MetricCard.types";
import { Path } from "@/router";

const DUES_METRIC_PLACEHOLDER: MetricCardType<Path> = {
  label: "Dues Status (Balance)",
  value: "",
  iconName: "paid",
  loading: true
};

export function useDuesStatus(person: Person) {
  const { data: duesOrdersData, loading } = useQuery<DuesOrdersData>(GET_PERSON_DUES_ORDERS_QUERY, {
    variables: {
      pgaId: person.pgaId || "",
      statuses: ACTIVE_DUES_ORDER_STATUSES
    },
    skip: !person.pgaId || !hasDuesPayingProgram(person)
  });

  const duesBalance = person.duesBalance || 0;
  const allOrders = duesOrdersData?.duesOrders?.nodes || [];

  // Find dues order that matches the person's current balance
  const matchingOrder = findMatchingDuesOrder(allOrders, person.pgaId || "", duesBalance);

  const duesMetric = matchingOrder
    ? buildDuesMetric(matchingOrder, person.pgaId, allOrders)
    : loading
      ? DUES_METRIC_PLACEHOLDER
      : null;

  return {
    duesMetric,
    matchingOrder,
    hasMatchingOrder: !!matchingOrder,
    loading
  };
}
